<template>

  <div>
    <at-ta
      :members="users"
      name-key="name">

      <template
        slot="item"
        slot-scope="s">
        <div class="d-flex">
          <div class="mr-2 align-self-center">
            <Avatar
              :src="s.item.photo_media_url && !s.item.photo_media_url.includes(defaultImageUrl) ? s.item.photo_media_url : null"
              :name="s.item.name"
              size="25px"
              radius="3px"
              resize="100x100x1" />
          </div>
          <div class="w-100 align-self-center">
            <span class="name text-truncate">{{ s.item.name }}</span>
          </div>
        </div>
      </template>

      <textarea-autosize
        :placeholder="placeholder"
        :min-height="30"
        :max-height="350"
        class="form-control"
        :value="value"
        @input="input">
        </textarea-autosize>

    </at-ta>
  </div>

</template>

<script>
import config from '@/config'
import AtTa from 'vue-at/dist/vue-at-textarea'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'TextareaMention',
  components: {
    AtTa,
    Avatar
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Use o @ para mencionar alguem'
    }
  },
  data () {
    return {
      users: ['Roxie Miles', 'grace.carroll', '小浩']
    }
  },
  computed: {
    defaultImageUrl () {
      return config.default_image_url.candidate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('getMembers', {sort: 'name', limit: 1000, active: true})
      .then((result) => {
        this.users = result.docs.map(v => v.user_id)
      })
    },
    input (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.name {
  display: block;
  max-width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/components/Fields/TextareaMention.vue